import { useTranslations } from 'next-intl'

import { TextButton } from '@/shared/ui'

type Props = {
  onClick: () => void
}

export const DeleteButton = ({ onClick }: Props) => {
  const t = useTranslations('search_panel')

  return (
    <TextButton onClick={onClick} className="absolute top-[34px] right-6">
      {t('recent_keyword.button.delete_all')}
    </TextButton>
  )
}
